import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { UpdateRecipeInput } from './UpdateRecipeInput';
import { UpdateRecipeOutput } from './UpdateRecipeOutput';

export class UpdateRecipeService extends HttpServiceBase {

  handle = (input: UpdateRecipeInput): Promise<Result<UpdateRecipeOutput> | null> => {
    const promise = this.http.put<Result<UpdateRecipeOutput>, UpdateRecipeInput>(`${this.baseUrlSislogApi}/v2/recipe`, input);
    return promise;
  }
}